import { compose, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import pipe from 'ramda/src/pipe';
import EditSubscriptionPlan from '../components/EditSubscriptionPlan';
import { trimData } from '../../../common/trimData';
import { modifySubscriptionPlan, fetchAllSubscriptionPlans, deleteSubscriptionPlan } from '../actions';
import { getSubscriptionPlanById } from '../reducer';
import withNotifications from '../../../common/withNotifications';
import confirmModal from '../../../common/confirmModal';
import { t } from '../../../../modules/infra/i18n';

const EditSubscriptionPlanContainer = compose(
  withNotifications,
  withRouter,
  connect(
    (state, ownProps) => ({
      initialValues: getSubscriptionPlanById(state, ownProps.params.id),
      id: ownProps.params.id,
    }),
    {
      fetchAllSubscriptionPlans,
      modifySubscriptionPlan,
      deleteSubscriptionPlan,
    }
  ),
  withHandlers({
    onSubmit: props => pipe(trimData, props.modifySubscriptionPlan.bind(null, props.id)),
    onDelete: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('subscription:edit.delete_plan_title'),
        message: t('subscription:edit.delete_plan_confirm'),
      });

      if (!confirmed) {
        return false;
      }
      return props.deleteSubscriptionPlan(props.id)
        .then(() => props.addNotification({
          title: t('subscription:edit.success_title'),
          level: 'success',
          message: t('subscription:edit.delete_success_message'),
        }))
        .then(() => props.router.replace('/admin/subscription/plans'));
    },
  }),
  lifecycle({
    componentDidMount() {
      if (!this.props.initialValues) {
        this.props.fetchAllSubscriptionPlans();
      }
    },
  })
)(EditSubscriptionPlan);

export default EditSubscriptionPlanContainer;
